module.exports = __webpack_public_path__ + "static/media/welcomeCIO_ElephantEnt.c070f62d.svg";